module.exports = __webpack_public_path__ + "1d220cf9da36861171fa90d3c164f4d3.svg";